<script setup lang="ts">
onMounted(() =>
  setTimeout(() => {
    const elements = document.getElementsByName('removePseudo');
    [...elements].forEach((el) => {
      el.remove();
    });
  }, 800),
);
</script>
<template>
  <div class="opacity-0 absolute">
    <input
      id="username"
      type="text"
      style="opacity: 0; position: absolute"
      name="removePseudo"
    />
    <input
      id="password"
      type="password"
      style="opacity: 0; position: absolute"
      name="removePseudo"
    />
    <input
      id="email"
      type="email"
      style="opacity: 0; position: absolute"
      name="removePseudo"
    />
    <input
      id="firstname"
      type="text"
      style="opacity: 0; position: absolute"
      name="removePseudo"
    />
    <input
      id="lastname"
      type="text"
      style="opacity: 0; position: absolute"
      name="removePseudo"
    />
    <input
      id="idNumber"
      type="text"
      style="opacity: 0; position: absolute"
      name="removePseudo"
    />
    <input
      id="dateOfBirth"
      type="text"
      style="opacity: 0; position: absolute"
      name="removePseudo"
    />
  </div>
</template>
